var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_c('v-icon',{attrs:{"color":_vm.icon.color}},[_vm._v(_vm._s(_vm.icon.icon)+" fa-fw")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.$t("sushi.state_desc." + _vm.fetchIntention.state))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }